import { useMemo } from 'react';

import SelectModal from '@/components/Select/SelectModal';
import type { ModalOptions, SelectOptionT } from '@/components/Select/types';
import { NOT_ASSIGNED_LABEL } from '@/configs/reserved-word';
import usePopupStore from '@/stores/pure/PopupStore';
import useWorkspaceStore from '@/stores/WorkspaceStore';

export type Props = {
  selected: string | null;
  useShortcut?: boolean;
  name: string;
  onSelect: (key: string) => void;
  onClear?: () => void;
  triggerEl?: HTMLDivElement | null;
  modalOptions?: ModalOptions;
};

const DataOriginSelectModal = (props: Props) => {
  const { workspaceFieldOptions, updateWorkspaceFieldOptions } =
    useWorkspaceStore(
      ({ workspaceFieldOptions, updateWorkspaceFieldOptions }) => ({
        workspaceFieldOptions,
        updateWorkspaceFieldOptions,
      }),
    );

  const setPopup = usePopupStore((state) => state.setPopup);

  const onDelete = (option: SelectOptionT) => {
    setPopup({
      popupTheme: 'negative',
      type: 'confirm',
      title: 'Delete the Data Origin',
      message: 'Are you sure you want to delete this Data Origin?',
      confirmText: 'Delete',
      cancelText: 'Cancel',
      onConfirm: () => {
        updateWorkspaceFieldOptions(4, 'data_origin', option.searchName);
      },
    });
  };

  const options: SelectOptionT[] = useMemo(() => {
    return workspaceFieldOptions.data_origin_values.map((data_origin) => ({
      value: data_origin,
      searchName: data_origin,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceFieldOptions.data_origin_values.join(',')]);

  return (
    <SelectModal
      width="250px"
      name={props.name}
      placeholder={NOT_ASSIGNED_LABEL}
      searchOptions={{
        enable: true,
        placeholder: 'Search existing or add new...',
      }}
      data={() => ({
        list: options,
        cursor: null,
      })}
      value={props.selected}
      onSelect={(key) => props.onSelect(key as string)}
      shortcut={'KeyD'}
      onDelete={onDelete}
      onCreate={(optionName) => {
        updateWorkspaceFieldOptions(1, 'data_origin', optionName);
      }}
      onClear={props.onClear}
      triggerEl={props.triggerEl}
      modalOptions={props.modalOptions}
    />
  );
};

export default DataOriginSelectModal;
